module.exports = __webpack_public_path__ + "static/media/edit.9ca05e35.svg";